module.exports = __webpack_public_path__ + "static/img/new-text.262e30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/new-text.png
// module id = fxMO
// module chunks = 1